import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { toast } from "sonner";
import { useUser } from "#/hooks/use-user";
import ChangeEmailCard from "./ChangeEmailCard";
import { jsx as _jsx } from "react/jsx-runtime";
export function ChangeEmailView(t0) {
  const $ = _c(10);
  const {
    authClient,
    onSuccess,
    onBack,
    statusMessage: initialStatusMessage
  } = t0;
  let t1;
  if ($[0] !== authClient) {
    t1 = {
      authClient
    };
    $[0] = authClient;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    updateEmail,
    isUpdating
  } = useUser(t1);
  const [statusMessage, setStatusMessage] = useState(initialStatusMessage);
  let t2;
  if ($[2] !== onSuccess || $[3] !== updateEmail) {
    t2 = async (email, password) => {
      const response = await updateEmail(email, password);
      if (response.success) {
        toast.success(response.message);
        setStatusMessage({
          message: response.message,
          variant: "confirmation"
        });
        if (onSuccess) {
          onSuccess();
        }
      } else {
        setStatusMessage({
          message: response.message,
          variant: "error"
        });
      }
      return response;
    };
    $[2] = onSuccess;
    $[3] = updateEmail;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleEmailUpdate = t2;
  let t3;
  if ($[5] !== handleEmailUpdate || $[6] !== isUpdating || $[7] !== onBack || $[8] !== statusMessage) {
    t3 = /*#__PURE__*/_jsx(ChangeEmailCard, {
      handleEmailUpdate: handleEmailUpdate,
      onBack: onBack,
      statusMessage: statusMessage,
      isLoading: isUpdating
    });
    $[5] = handleEmailUpdate;
    $[6] = isUpdating;
    $[7] = onBack;
    $[8] = statusMessage;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}